<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'advance-search-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #body>
      <h3 class="dialogTitle">Tìm kiếm nâng cao</h3>
      <el-form :model="form" label-position="right">
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Số ký hiệu" class="formItem">
              <el-input
                v-model="advanceSearchForm.docCode"
                size="medium"
                class=""
                placeholder="-"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Trích yếu" class="formItem">
              <el-input
                v-model="advanceSearchForm.quote"
                size="medium"
                class=""
                placeholder="-"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Nội dung văn bản" class="formItem">
              <el-input
                v-model="advanceSearchForm.fileContent"
                size="medium"
                class=""
                placeholder="-"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="14">
            <el-form-item label="Ngày văn bản" class="formItem">
              <el-date-picker
                v-model="docDateRange"
                type="daterange"
                format="dd/MM/yyyy"
                class="
                  style-fullWidth
                  input-border__bottom input-border__radius__0
                  bg__transparent
                "
                :picker-options="dateQuickFilterOption"
                range-separator="_"
                start-placeholder="_"
                end-placeholder="_"
                align="right"
                @change="docDateRangeChanged"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Ngày đến" class="formItem labelWidth__auto">
              <el-date-picker
                v-model="incomingDateRange"
                type="daterange"
                format="dd/MM/yyyy"
                class="
                  style-fullWidth
                  input-border__bottom input-border__radius__0
                  bg__transparent
                "
                :picker-options="dateQuickFilterOption"
                range-separator="_"
                start-placeholder="_"
                end-placeholder="_"
                align="right"
                @change="incomingDateRangeChanged"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="" class="formItem">
              <template #label>
                <span class="flex-row flex__left">
                  Đơn vị phát hành (bên trong) &nbsp;
                  <i
                    class="fas fa-cog advance-search color__cyan clickable"
                    @click="isOpenSelectDepartmentDialog = true"
                  ></i>
                </span>
              </template>
              <el-select
                filterable
                clearable
                v-model="advanceSearchForm.publisherId"
                size="medium"
                placeholder="-"
                class="style-fullWidth"
              >
                <el-option
                  v-for="item in receiveDepartments"
                  :label="item.deptName"
                  :key="item.id"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item class="formItem" label="Đơn vị phát hành (bên ngoài)">
              <el-input
                v-model="advanceSearchForm.outsidePublisherName"
                size="medium"
                class=""
                placeholder="-"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Loại văn bản" class="formItem">
              <el-select
                clearable
                filterable
                v-model="advanceSearchForm.docTypeId"
                size="medium"
                placeholder="-"
                class="style-fullWidth"
              >
                <el-option
                  v-for="item in docTypes"
                  :key="item.id"
                  :label="item.categoryName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="search">
          <i class="fal fa-search font-size__small"></i>
          &nbsp;Tìm kiếm
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="reset"
          >Khởi tạo
        </el-button>

        <selectDepartmentDialog
          :isOpen="isOpenSelectDepartmentDialog"
          v-if="isEnableSelectDepartmentDialog"
          @closed="isEnableSelectDepartmentDialog = false"
          @closeDialog="isOpenSelectDepartmentDialog = false"
          @change="publisherDepartmentChange"
        >
        </selectDepartmentDialog>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import h from "../../../services/h";
import constants from "../../../constants";
import categoryViewService from "../../../services/categoryViewService";
import departmentService from "../../../services/departmentService";
import utils from "../../../services/utils";
import otherDepartmentService from "../../../services/otherDepartmentService";
import dateUtils from "../../../dateUtils";

export default {
  name: "vbdavaoso-advance-search-dialog",
  props: ["isOpen", "form"],
  components: {
    customDialog: () => import("../../common/custom-dialog.vue"),
    selectDepartmentDialog: () =>
      import("../../common/commonSelectDepartmentDialog"),
  },

  data() {
    return {
      insideReceiver: "",
      listInsideReceiver: [],
      isLoading: false,
      receiveDepartments: [],
      docDateRange: null,
      incomingDateRange: null,
      docTypes: [],
      departments: [],
      isOpenSelectDepartmentDialog: false,
      isEnableSelectDepartmentDialog: false,
      advanceSearchForm: {
        docCode: null,
        quote: null,
        fileContent: null,
        docTypeId: null,
        publisherId: null,
        outsidePublisherName: null,
        fromDocDate: null,
        toDocDate: null,
        fromIncomingDate: null,
        toIncomingDate: null,
      },

      dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),
    };
  },

  computed: {
    deptId() {
      return this.$store.getters.userDeptRole.deptId;
    },
  },

  watch: {
    isOpenSelectDepartmentDialog(newValue) {
      newValue && (this.isEnableSelectDepartmentDialog = newValue);
    },
  },

  mounted() {
    this.loadCategories();
    this.loadDepartments();
    this.initForm();
  },

  methods: {
    initForm() {
      this.advanceSearchForm.docCode = this.form.docCode;
      this.advanceSearchForm.quote = this.form.quote;
      this.advanceSearchForm.fileContent = this.form.fileContent;
      this.advanceSearchForm.docTypeId = this.form.docTypeId;
      this.advanceSearchForm.publisherId = this.form.publisherId;
      this.advanceSearchForm.outsidePublisherName =
        this.form.outsidePublisherName;
      this.advanceSearchForm.fromDocDate = this.form.fromDocDate;
      this.advanceSearchForm.toDocDate = this.form.toDocDate;
      this.advanceSearchForm.fromIncomingDate = this.form.fromIncomingDate;
      this.advanceSearchForm.toIncomingDate = this.form.toIncomingDate;
      this.initDocDateRange();
      this.initIncomingDateRange();
    },

    initDocDateRange() {
      if (
        this.advanceSearchForm.fromDocDate ||
        this.advanceSearchForm.toDocDate
      ) {
        this.docDateRange = [
          dateUtils.toMoment(this.advanceSearchForm.fromDocDate),
          dateUtils.toMoment(this.advanceSearchForm.toDocDate),
        ];
      } else {
        this.docDateRange = null;
      }
    },

    initIncomingDateRange() {
      if (
        this.advanceSearchForm.fromIncomingDate ||
        this.advanceSearchForm.toIncomingDate
      ) {
        this.incomingDateRange = [
          dateUtils.toMoment(this.advanceSearchForm.fromIncomingDate),
          dateUtils.toMoment(this.advanceSearchForm.toIncomingDate),
        ];
      } else {
        this.incomingDateRange = null;
      }
    },

    docDateRangeChanged() {
      this.advanceSearchForm.fromDocDate =
        this.docDateRange && this.docDateRange[0]
          ? this.docDateRange[0].getTime()
          : undefined;
      this.advanceSearchForm.toDocDate =
        this.docDateRange && this.docDateRange[1]
          ? this.docDateRange[1].getTime()
          : undefined;
    },

    incomingDateRangeChanged() {
      this.advanceSearchForm.fromIncomingDate =
        this.incomingDateRange && this.incomingDateRange[0]
          ? this.incomingDateRange[0].getTime()
          : undefined;
      this.advanceSearchForm.toIncomingDate =
        this.incomingDateRange && this.incomingDateRange[1]
          ? this.incomingDateRange[1].getTime()
          : undefined;
    },

    remoteMethod(query) {
      if (query !== "") {
        this.findOtherDept(query);
      } else {
        this.options = [];
      }
    },

    findOtherDept(query) {
      this.isLoading = true;
      otherDepartmentService
        .search(query, this.deptId, { sort: "count,desc", page: 0, size: 20 })
        .then((res) => {
          this.listInsideReceiver = res.data;
          this.isLoading = false;
        });
    },

    prepareReceiveDepartments() {
      this.receiveDepartments = departmentService
        .prepareReceiveDepartments(this.deptId, this.departments)
        .filter((item) => item.id !== "ROOT");
    },

    publisherDepartmentChange(event) {
      let department = event.selectedDepartment;
      this.form.publisherId = department ? department.id : null;
      this.isOpenSelectDepartmentDialog = false;
    },

    loadDepartments() {
      departmentService.findAll().then((response) => {
        this.departments = response.data;
        this.prepareReceiveDepartments();
      });
    },

    loadCategories() {
      h.each([constants.CATEGORY_GROUP_CODE.DOC_TYPE], (item) => {
        categoryViewService
          .findAll(
            { groupCode: item },
            { sort: "order,asc", page: 0, size: 1000 }
          )
          .then((response) => {
            switch (item) {
              case constants.CATEGORY_GROUP_CODE.DOC_TYPE:
                return (this.docTypes = response.data.filter(
                  (item) => item.status !== "deactive"
                ));
            }
          });
      });
    },

    search() {
      let advanceSearchForm = {
        docCode: utils.nvl(this.advanceSearchForm.docCode, undefined),
        quote: utils.nvl(this.advanceSearchForm.quote, undefined),
        fileContent: utils.nvl(this.advanceSearchForm.fileContent, undefined),
        docTypeId: utils.nvl(this.advanceSearchForm.docTypeId, undefined),
        publisherId: utils.nvl(this.advanceSearchForm.publisherId, undefined),
        outsidePublisherName: utils.nvl(
          this.advanceSearchForm.outsidePublisherName,
          undefined
        ),
        toIncomingDate: utils.nvl(
          this.advanceSearchForm.toIncomingDate,
          undefined
        ),
        fromIncomingDate: utils.nvl(
          this.advanceSearchForm.fromIncomingDate,
          undefined
        ),
        fromDocDate: utils.nvl(this.advanceSearchForm.fromDocDate, undefined),
        toDocDate: utils.nvl(this.advanceSearchForm.toDocDate, undefined),
      };
      this.$emit("doSearch", { advanceSearchForm: advanceSearchForm });
      this.$emit("closeDialog");
    },

    reset() {
      this.advanceSearchForm.docCode = null;
      this.advanceSearchForm.quote = null;
      this.advanceSearchForm.fileContent = null;
      this.advanceSearchForm.docTypeId = null;
      this.advanceSearchForm.publisherId = null;
      this.advanceSearchForm.outsidePublisherName = null;
      this.advanceSearchForm.fromIncomingDate = null;
      this.advanceSearchForm.toIncomingDate = null;
      this.advanceSearchForm.fromDocDate = null;
      this.advanceSearchForm.toDocDate = null;
      this.initDocDateRange();
      this.initIncomingDateRange();
    },
  },
};
</script>

<style scoped>
.form {
  padding: 12px 20px 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/vbdavaoso-advance-search-dialog.vue